export enum TestType {
  NONE = "",
  BEFORE_TEST = "BEFORE_TEST",
  AFTER_TEST = "AFTER_TEST",
  ACCURACY_MORE = "ACCURACY_MORE",
  ACCURACY_LESS = "ACCURACY_LESS"
}
